import { classed } from "@/components/classed.config";

export const Overlay = classed.div("fixed inset-0 z-50");

export const OverlayBackdrop = classed.div(
  "absolute inset-0 bg-gray-500/30 backdrop-blur-xs backdrop-filter transition-opacity",
);
